import { render, staticRenderFns } from "./AuthorityBox.vue?vue&type=template&id=0a5d333e&scoped=true&"
import script from "./AuthorityBox.vue?vue&type=script&lang=js&"
export * from "./AuthorityBox.vue?vue&type=script&lang=js&"
import style0 from "./AuthorityBox.vue?vue&type=style&index=0&id=0a5d333e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5d333e",
  null
  
)

export default component.exports